import styled from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
  margin: 2rem;
  margin-bottom: 0;
  flex-direction: column;
  justify-content: center;
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  background-color: #fff;

  @media (max-width: 768px) {
    margin: 0.5rem;
  }
`;

export const TabBar = styled.div`
  height: 10%;
  display: flex;
  border-bottom: 1px solid #ccc;
`;

export const TabPanel = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
`;
